var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleIcon = function SvgGoogleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9926 8.134C13.9926 7.54727 13.9449 7.11911 13.8419 6.67509H7.1394V9.32332H11.0736C10.9943 9.98144 10.566 10.9726 9.61414 11.6386L9.6008 11.7272L11.72 13.3683L11.8668 13.383C13.2152 12.1381 13.9926 10.3065 13.9926 8.134Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13948 15.1114C9.06691 15.1114 10.685 14.4771 11.8669 13.3829L9.61422 11.6385C9.0114 12.0587 8.20233 12.3521 7.13948 12.3521C5.2517 12.3521 3.64946 11.1073 3.07831 9.38675L2.99459 9.39386L0.791024 11.0986L0.762207 11.1786C1.93612 13.5097 4.34742 15.1114 7.13948 15.1114Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07828 9.38674C2.92758 8.94273 2.84036 8.46696 2.84036 7.97539C2.84036 7.48377 2.92758 7.00805 3.07035 6.56404L3.06636 6.46948L0.835178 4.73738L0.762177 4.77209C0.278352 5.73943 0.000732422 6.82571 0.000732422 7.97539C0.000732422 9.12508 0.278352 10.2113 0.762177 11.1786L3.07828 9.38674Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13948 3.59865C8.47995 3.59865 9.38417 4.17746 9.89977 4.66115L11.9145 2.69478C10.6771 1.54509 9.06691 0.839417 7.13948 0.839417C4.34742 0.839417 1.93612 2.44104 0.762207 4.77211L3.07038 6.56407C3.64946 4.8435 5.2517 3.59865 7.13948 3.59865Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14.3212,
    fill: "white",
    transform: "translate(0 0.839401)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-icon.023570d6.svg";
export { ForwardRef as ReactComponent };